import moment from "moment";

export default {
  getParsed(packet) {
    return packet
      ? packet.source_data
        ? packet.source_data.parsed
        : null
      : null;
  },

  getFirstParsed(packets) {
    let parsed = null;
    packets.forEach(packet => {
      if (
        !parsed &&
        packet &&
        packet.source_data &&
        packet.source_data.parsed
      ) {
        parsed = packet.source_data.parsed;
      }
    });
    return parsed;
  },

  removeElement(array, deviceType) {
    // console.log(array, deviceType)
    if (deviceType) {
      var displayConfig = deviceType.niota_maps.display_config;
      displayConfig = JSON.parse(displayConfig);
      var deviceOptions = Object.keys(displayConfig);
      for (let x = 0; x < deviceOptions.length; x++) {
        var currentConfig = displayConfig[deviceOptions].hideKey;
        if (currentConfig.length) {
          for (let i = 0; i < currentConfig.length; i++) {
            var index = array.indexOf(currentConfig[i]);
            if (index > -1) {
              array.splice(index, 1);
            } else console.log(currentConfig[i] + " not found!");
          }
        }
      }
    }
  },

  getArray(parsed, deviceType) {
    let packetArray = [];
    var keys = Object.keys(parsed);
    this.removeElement(keys, deviceType);
    keys.forEach(key => {
      if (key === "gps") {
        return packetArray.push({
          key: key,
          value: `${parsed[key].latitude}, ${parsed[key].longitude}`
        });
      }
      packetArray.push({
        key: key,
        value: parsed[key]
      });
    });
    return packetArray;
  },

  getGraphData(packets) {
    let vm = this;
    let graphData = {
      _dates: []
    };

    packets.forEach(packet => {
      if (!vm.getParsed(packet)) {
        return;
      }
      graphData._dates.push(
        moment(packet.source_time).format("hh:ss - DD.MM.YY")
      );

      Object.keys(packet.source_data.parsed).forEach(key => {
        if (!graphData[key]) {
          graphData[key] = [];
        }
        graphData[key].push(packet.source_data.parsed[key]);
      });
    });

    return graphData;
  },

  getPositionHistory(packets) {
    let coordinates = [];
    if (packets && packets.length) {
      packets.forEach(packet => {
        let parsed = this.getParsed(packet);
        if (
          parsed &&
          parsed.gps &&
          parsed.gps.latitude !== 0 &&
          parsed.gps.longitude !== 0
        ) {
          coordinates.unshift({
            gps: [parsed.gps.longitude, parsed.gps.latitude],
            uid: packet.uid,
            source_time: packet.source_time
          });
        }
      });
    }
    return coordinates;
  },

  getFeaturesByCoordinates(coordinates) {
    return coordinates.map(point => {
      return {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: point.gps
        },
        properties: {
          uid: point.uid,
          source_time: point.source_time
        }
      };
    });
  },

  getDeviceClassUrl(packet) {
    let url = false;
    let sourceData = packet.source_data ? packet.source_data : {};
    let deviceClassId = sourceData.device_class
      ? sourceData.device_class.id
      : null;

    if (deviceClassId) {
      url =
        process.env.VUE_APP_NIOTA_URL + `/#!/app/deviceclass/${deviceClassId}`;
    }

    return url;
  },

  getGPS(packets) {
    let hasGPS = false;
    if (packets && packets.length) {
      packets.forEach(packet => {
        let parsed = this.getParsed(packet);
        if (!hasGPS && parsed && this.parsedHasGPS(parsed)) {
          hasGPS = parsed.gps;
        }
      });
    }
    return hasGPS;
  },

  getGPSreverse(packets) {
    let hasGPS = false;
    if (packets && packets.length) {
      packets.forEach(packet => {
        let parsed = this.getParsed(packet);
        if (parsed && this.parsedHasGPS(parsed)) {
          hasGPS = parsed.gps;
        }
      });
    }
    return hasGPS;
  },

  hasParsed(packets) {
    let hasParsed = false;
    if (packets && packets.length) {
      packets.forEach(packet => {
        let parsed = this.getParsed(packet);
        if (parsed) {
          hasParsed = true;
        }
      });
    }
    return hasParsed;
  },

  parsedHasGPS(parsed) {
    return parsed.gps && parsed.gps.valid;
  }
};
